export const dateFormatter = date => {
  const newDate = new Date(date);
  return `${newDate.getFullYear()}-${newDate.getMonth() +
    1}-${newDate.getDate()}`;
};

export const currencyFormatter = value => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(value);
};

const numberWithCommas = x => {
  return x
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    .replace('.00', '');
};

export const numberFormatter = value => {
  return numberWithCommas(value.toFixed(2));
};
